import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { Globe } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function LanguageSwitcher() {
  const { t, i18n } = useTranslation();

  const handleLanguageChange = async (lang: any) => {
    try {
      // Change language in UI
      await i18n.changeLanguage(lang);
      
      // Save to backend if user is logged in
      if (localStorage.getItem('user')) {
        await axios.patch(`${API}/auth/profile`, {
          preferred_language: lang
        });
      }
      
      // toast.success(t('settings.languageChanged'));
    } catch (error: any) {
      console.error('Error changing language:', error);
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="gap-2" data-testid="language-switcher">
          <Globe className="w-4 h-4" />
          {i18n.language === 'no' ? 'NO' : 'EN'}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem 
          onClick={() => handleLanguageChange('no')}
          className={i18n.language === 'no' ? 'bg-muted' : ''}
        >
          🇳🇴 {t('settings.norwegian')}
        </DropdownMenuItem>
        <DropdownMenuItem 
          onClick={() => handleLanguageChange('en')}
          className={i18n.language === 'en' ? 'bg-muted' : ''}
        >
          🇬🇧 {t('settings.english')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
